import { PageId } from '~/shared/constants/pagesConstants'

// Single source of truth for each text-options question's correct option
// key — used both by the question page itself and by the section-complete
// screen that tallies up how many were answered correctly.
export const TEXT_OPTIONS_CORRECT_ANSWERS: Partial<Record<PageId, string>> = {
  [PageId.LOWER_BACK_PAIN_ANATOMY_V2_1]: 'tightHips',
  [PageId.NECK_STRAIN_ANATOMY_V2_1]: 'phone',
  [PageId.SHOULDER_PAIN_ANATOMY_V2_1]: 'both',
  [PageId.VAGUS_NERVE_ANATOMY_V2_1]: 'heartSlows',
}
